export class ObjectiveCategory {
    id: number;
    name: string;
    minNumber: number;
    maxNumber?: number;
    viewHr: boolean;
    editHr: boolean;
    viewEmpMgr: boolean;
    editEmpMgr: boolean;
    sort?: number;
    weight?: number;
    deleted: number;
    deletedById: number;
    deletedByKind: number;
    isInUse: number;
    isMaxCountReached: boolean;
    isMaxWeightReached: boolean;
}